import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])
  let toastId = 0

  const addToast = (options) => {
    const id = ++toastId
    const toast = {
      id,
      type: options.type || 'info',
      title: options.title || 'Bildirim',
      message: options.message || '',
      duration: options.duration || 5000,
      autoClose: options.autoClose !== false
    }
    
    toasts.value.push(toast)
    
    if (toast.autoClose) {
      setTimeout(() => {
        removeToast(id)
      }, toast.duration)
    }
    
    return id
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  // Kısa yollar
  const success = (title, message = '') => addToast({ type: 'success', title, message })
  const error = (title, message = '') => addToast({ type: 'error', title, message })
  const warning = (title, message = '') => addToast({ type: 'warning', title, message })
  const info = (title, message = '') => addToast({ type: 'info', title, message })

  return {
    toasts,
    addToast,
    removeToast,
    success,
    error,
    warning,
    info
  }
})
